import React from 'react'
import { useSelector } from 'react-redux'

import { getActiveModal } from '../../ducks/modals'
import { ADD_INPUT_MODAL } from '../../utils/modal-types'

import Modal from '../Shared/Modal'
import AddInputModal from '../Actions/AddInput'

export const renderModal = ({ modalType, options, resolve, reject }) => {
  const props = {
    ...options,
    onSuccess: resolve,
    onCancel: reject,
  }

  switch (modalType) {
    case ADD_INPUT_MODAL:
      return <AddInputModal {...props} />
  }

  return null
}

export default function Modals() {
  let activeModal = useSelector(getActiveModal)

  if (!activeModal) return null

  return <Modal onClose={activeModal.reject}>{renderModal(activeModal)}</Modal>
}
